import { QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { GC_TIME } from "../ts/const";

//  tanstack-query 디폴트 설정
const DEFAULT_QUERY_OPTIONS = {
    staleTime: 0,
    gcTime: GC_TIME,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
}

export function useCustomQuery<
    TQueryFnData = unknown,
    TError = unknown,
    TData = TQueryFnData,
    TQueryKey extends QueryKey = QueryKey
>(
    options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>
): UseQueryResult<TData, TError> {
    return useQuery({
        ...DEFAULT_QUERY_OPTIONS,
        ...options,
    });
}

export default useCustomQuery;